import { Enum } from 'enumify';

class EmbedPlayerStatus extends Enum {}

EmbedPlayerStatus.initEnum(['LOADING', 'READY']);

export default EmbedPlayerStatus;
